import { render } from "./FormBox.vue?vue&type=template&id=8e85202c"
import script from "./FormBox.vue?vue&type=script&setup=true&lang=js"
export * from "./FormBox.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Sources/JavaScript/Extensions/Lfmpublications/Vue/components/FormBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8e85202c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8e85202c', __exports__)) {
    api.reload('8e85202c', __exports__)
  }
  
  module.hot.accept("./FormBox.vue?vue&type=template&id=8e85202c", () => {
    api.rerender('8e85202c', render)
  })

}


export default __exports__